module.exports = __webpack_public_path__ + "img/guardtower_tech_Normal_ua.1571ef96.webp";